<template>
  <v-app id="inspire">
    <navigation-drawer />
    <app-bar />
    <v-main>
      <tabbar />
      <transition name="default">
        <v-container v-show="animate" fluid>
          <v-snackbar
            absolute
            top
            right
            color="primary"
            timeout="6000"
            :value="flash"
          >
            {{ $page.props.jetstream.flash }}

            <template #action="{ attrs }">
              <v-icon v-bind="attrs" @click="flashDismissed = true">
                mdi-close
              </v-icon>
            </template>
          </v-snackbar>

          <slot />
        </v-container>
      </transition>
    </v-main>
  </v-app>
</template>

<script>
import Tabbar from '@/Components/Layout/Tabbar'
export default {
   name: 'Layout',
   components: {
      Tabbar,
   },
   data () {
      return {
         showUserMenu: false,
         accounts: null,
         animate: false,
         flashDismissed: false,
      }
   },
   computed: {
      flash () {
         if (this.flashDismissed) {
            return false
         }

         return this.$page.props.jetstream.flash.length > 0
      },
   },
   mounted () {
      this.animate = true
      this.$inertia.on('start', (event) => {
         console.log(event)
         if (event.detail.visit.method === 'get') {
            this.animate = false
         }
      })

      this.$inertia.on('finish', (event) => {
         console.log(event)
         this.animate = true
      })
   },
   created () {
      console.log('created')
   },
   methods: {
      url () {
         return location.pathname.substr(1)
      },
      hideDropdownMenus () {
         this.showUserMenu = false
      },
   },
}
</script>
<style>
.default-enter-active {
  -webkit-animation: slide-in-right 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)
    both;
  animation: slide-in-right 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}

.default-leave-active {
  -webkit-animation: slide-out-left 0.5s cubic-bezier(0.55, 0.085, 0.68, 0.53)
    both;
  animation: slide-out-left 0.5s cubic-bezier(0.55, 0.085, 0.68, 0.53) both;
}

/* .default-enter,
.default-leave-active {
  opacity: 0;
} */

/* ----------------------------------------------
 * Generated by Animista on 2021-3-22 14:27:32
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info.
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation slide-in-right
 * ----------------------------------------
 */
@-webkit-keyframes slide-in-right {
  0% {
    -webkit-transform: translateX(1000px);
    transform: translateX(1000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}
@keyframes slide-in-right {
  0% {
    -webkit-transform: translateX(1000px);
    transform: translateX(1000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}

/**
 * ----------------------------------------
 * animation slide-out-left
 * ----------------------------------------
 */
@-webkit-keyframes slide-out-left {
  0% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
  100% {
    -webkit-transform: translateX(-1000px);
    transform: translateX(-1000px);
    opacity: 0;
  }
}
@keyframes slide-out-left {
  0% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
  100% {
    -webkit-transform: translateX(-1000px);
    transform: translateX(-1000px);
    opacity: 0;
  }
}
</style>
